export class NetworkContractFilterForm {
  code: string;
  client: string;
  number: string;
  contractType: string;
  placeId: number;
  companyCode?: string;
  active?: boolean;

  pageSize = 10;
  pageOffset = 0;
}
